<template>
    <div class="productNumberOfShopMain" @click.self="removeDialog">
        <div class="frame">
            <p style="width:100%;text-align:center;">产品数量</p>
            <div class="horizonGully" />
            <div class="horizonDivider" />
            <div class="horizonGully" />
            
            <input style="width:100%;text-align:center;" v-model="number" />
            <div class="horizonGully" />
            <div class="horizonDivider" />
            <div class="horizonGully" />

            <button style="width:100%;" @click="confirm">确认</button>
            <div class="horizonGully" />
            <button style="width:100%;" @click="removeDialog">取消</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductNumberOfShop",

    props: {
        initNumber: {
            type: Number,
            default: 0,
        }
    },

    data()
    {
        return {
            number: 0,
        }
    },

    created()
    {
        this.number = this.initNumber;
    },

    methods: {
        confirm()
        {
            this.$emit("dataChange", this.number);

            //
            this.remove();
        },

        removeDialog()
        {
            this.remove();
        },
    }
}
</script>

<style lang="scss" scoped>

//
.productNumberOfShopMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $fontSizeContent;
    line-height: 2em;
}

.frame {
    width: 80vw;
    max-height: 80vh;
    box-sizing: border-box;
    padding: $padding;
    background-color: #ffffff;
}


</style>